<template>
  <div class="filter-container">
    <el-card class="custom-card" shadow="never">
      <el-form ref="detail" :rules="rules" :model="detail" label-position="left" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- <el-form-item :label="`设备类型`" prop="DevVersion">
              <el-radio-group v-model="detail.DevVersion">
                <el-radio-button :label="0">9寸</el-radio-button>
                <el-radio-button :label="1">21寸</el-radio-button>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item :label="$t(`table.deviceName`)" prop="Name">
              <el-input v-model="detail.Name" :placeholder="$t(`table.deviceName`)" type="text" maxlength="20" />
            </el-form-item>
            <el-form-item :label="`经度`" prop="Longitude">
              <el-input v-model="detail.Longitude" :placeholder="`经度`" type="text" maxlength="50" />
            </el-form-item>
            <el-form-item :label="`设备地址`" prop="Address">
              <el-input v-model="detail.Address" :placeholder="`设备地址`" type="text" maxlength="50" @change="handleInputAddress" />
            </el-form-item>
            <!-- <el-form-item :label="`是否免费`">
            <el-select v-model="detail.IsFree" placeholder="请选择">
              <el-option
                v-for="item in YesNo"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item :label="$t(`table.DetailAdress`)" prop="newstitle">
            <el-input v-model="detail.FieldInfo.MonthlyDiscount" type="number" maxlength="50" placeholder="请输入包月折扣" />
          </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item :label="`设备分组`" prop="DevGroupId">
              <el-select v-model="detail.DevGroupId" clearable placeholder="设备分组">
                <el-option v-for="item in groupArr" :key="item.GroupId" :value="item.GroupId" :label="item.GroupName">
                  <span style="float: left;">{{ item.GroupName }}</span>
                  <el-link :underline="false" style="float: right;" type="danger" @click.stop="updateGroup(item)">编辑</el-link>
                </el-option>
              </el-select>
              <el-button type="primary" @click="updateGroup()">添加</el-button>
            </el-form-item> -->
            <el-form-item :label="$t(`table.imei`)" prop="Identity">
              <el-input v-model="detail.Identity" :placeholder="$t(`table.imei`)" type="text" maxlength="20" />
            </el-form-item>
            <el-form-item :label="`纬度`" prop="Latitude">
              <el-input v-model="detail.Latitude" :placeholder="`纬度`" type="text" maxlength="50" />
            </el-form-item>
          </el-col>
        </el-row>
        <div id="bmap"/>
        <el-row :gutter="20" class="mt-20">
          <el-col :span="12">
            <el-form-item :label="$t(`table.isDepositTel`)" prop="IsDepositTel">
              <el-select v-model="detail.IsDepositTel " :placeholder="$t('table.isDepositTel')" clearable>
                <el-option v-for="item in YesNo" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>

            <!-- <el-form-item :label="`箱子编号`" prop="BoxCode">
              <el-input v-model="detail.BoxCode" :placeholder="`箱子编号(A-Z)`" type="text" maxlength="50" />
            </el-form-item>
            <el-form-item :label="`小箱子备注`" prop="SmallMemo">
              <el-input v-model="detail.SmallMemo " :placeholder="`小箱子备注`" type="text" maxlength="15" />
            </el-form-item>
            <el-form-item :label="`箱子备注`" prop="MidMemo">
              <el-input v-model="detail.MidMemo" :placeholder="`箱子备注`" type="text" maxlength="15" />
            </el-form-item>
            <el-form-item :label="`大箱子备注`" prop="BigMemo">
              <el-input v-model="detail.BigMemo " :placeholder="`大箱子备注`" type="text" maxlength="15" />
            </el-form-item>
            <el-form-item :label="`超级大箱子备注`" prop="SuperBigMemo">
              <el-input v-model="detail.SuperBigMemo " :placeholder="`超级大箱子备注`" type="text" maxlength="15" />
            </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item :label="`员工柜子数量`" prop="MemberCount">
              <el-input v-model="detail.MemberCount" :placeholder="`最大员工柜子数量`" type="number" maxlength="4" />
            </el-form-item> -->
            <!-- <el-form-item :label="`箱子大小`" prop="TypeNo">
              <el-select v-model="detail.TypeNo">
                <el-option
                  v-for="item in boxType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>

            </el-form-item> -->
            <el-form-item :label="`一拖几`" prop="CabinetCount">
              <el-input v-model="detail.CabinetCount" :placeholder="`一拖几，请填写大于等于0的数字`" type="number" maxlength="50" />
            </el-form-item>
            <el-form-item :label="`几门`" prop="DoorCount">
              <el-input v-model="detail.DoorCount" :placeholder="`请填写数字，如：1`" type="number" maxlength="50" />
            </el-form-item>

            <!-- <template v-if="roleId === 1">
              <el-form-item :label="`是否开启NPC`">
                <el-select v-model="detail.IsOpenHide" placeholder="请选择">
                  <el-option
                    v-for="item in isOpenHideOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item v-if="detail.IsOpenHide" :label="`NPC概率`" prop="HideProportion">
                <el-input v-model="detail.HideProportion" placeholder="请输入NPC概率"/>
              </el-form-item>
              <el-form-item v-if="detail.IsOpenHide" :label="`NPC基数`" prop="StartHideCount">
                <el-input v-model="detail.StartHideCount" placeholder="请输入NPC基数"/>
              </el-form-item>
              <el-form-item v-if="detail.IsOpenHide" :label="`最多NPC数`" prop="StartHideCount">
                <el-input v-model="detail.MaxHideCount" placeholder="请输入最多NPC数"/>
              </el-form-item>
            </template> -->
            <el-form-item label="广告图">
              <file-upload ref="upload" @change="uploadChange"/>
            </el-form-item>

          </el-col>
        </el-row>
        <div class="flex">
          <el-button style="margin-left: auto" class="filter-item" round type="info" @click="cancel">{{ $t('table.cancel') }}</el-button>
          <template v-if="status">
            <el-button class="filter-item" round type="primary" @click="submit('detail')">{{ $t('table.submit') }}</el-button>
          </template>
          <template v-else>
            <el-button class="filter-item" round type="primary" @click="submit('detail')">{{ $t('table.submit') }}</el-button>
          </template>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { txDevice, qryDeviceGroup, addDeviceGroup, modDeviceGroup } from '@/api/device'
import BaiduMap from '../../../static/map.js'
import waves from '@/directive/waves' // 水波纹指令
import FileUpload from '@/components/FileUpload/index4'
export default {
  name: 'AddNews',
  directives: {
    waves
  },
  components: {
    FileUpload
  },
  props: {
    detail: {
      type: Object,
      default: function() {
        return {
          Name: null,
          Identity: null,
          Address: null,
          MemberCount: null,
          IsDepositTel: 'N',
          SmallMemo: null,
          MidMemo: null,
          BigMemo: null,
          SuperBigMemo: null,
          BoxCode: null,
          IsFree: 'N',
          Longitude: null,
          Latitude: null,
          IsOpenHide: 0,
          HideProportion: null,
          CabinetCount: null,
          DoorCount: null,
          TypeNo: 'Small',
          DevVersion: 0,
          DevGroupId: null,
          AdvPic: undefined
        }
      }
    },
    status: {
      type: Boolean,
      default: null
    }
  },
  data() {
    var validatorLetter = (rule, value, callback) => {
      if (!value) {
        console.log(111)
        callback()
      } else {
        if (/^[A-Z]$/.test(value)) {
          callback()
        } else {
          callback(new Error('请填写A-Z之间的大写字母'))
        }
      }
    }
    var validateHide = (rule, value, callback) => {
      if (/^(1|0)\.?\d{0,4}$/.test(value) && value <= 1 && value > 0) {
        callback()
      } else {
        callback(new Error('请输入大于0 小于等于1的数字，最多支持4位小数'))
      }
    }
    var validateBase = (rule, value, callback) => {
      if (/^[1-9][0-9]*$/.test(value)) {
        callback()
      } else {
        callback(new Error('只能输入大于0的正整数'))
      }
    }
    var validateCount = (rule, value, callback) => {
      if (/^[1-9][0-9]*$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入大于0的正整数'))
      }
    }

    var validateCountMaxZero = (rule, value, callback) => {
      if (/^[0-9]+$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入大于等于0的正整数'))
      }
    }
    return {
      boxType: [
        { label: '小', value: 'Small' },
        { label: '中', value: 'Mid' },
        { label: '大', value: 'Big' },
        { label: '超大', value: 'SuperBig' }
      ],
      rules: {
        Name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        Identity: [{ required: true, message: '请输入设备标识号', trigger: 'blur' }],
        Address: [{ required: true, message: '请输入设备地址', trigger: 'blur' }],
        MemberCount: [{ required: true, message: '请输入最大员工柜子数量', trigger: 'blur' }],
        IsDepositTel: [{ required: true, message: '请选择是否支持手机', trigger: 'blur' }],
        SmallMemo: [{ required: false, message: '请输入小箱子备注', trigger: 'blur' }],
        MidMemo: [{ required: false, message: '请输入中箱子备注', trigger: 'blur' }],
        BigMemo: [{ required: false, message: '请输入大箱子备注', trigger: 'blur' }],
        SuperBigMemo: [{ required: false, message: '请输入超级大箱子备注', trigger: 'blur' }],
        BoxCode: [{ validator: validatorLetter, trigger: 'blur' }],
        HideProportion: [
          { validator: validateHide, trigger: 'blur' }
        ],
        StartHideCount: [
          { validator: validateBase, trigger: 'blur' }
        ],
        DoorCount: [
          { required: true, message: '请输入多少柜门', trigger: 'blur' },
          { validator: validateCount, trigger: 'blur' }
        ],
        CabinetCount: [
          { required: true, message: '请输入一拖几', trigger: 'blur' },
          { validator: validateCountMaxZero, trigger: 'blur' }
        ],
        TypeNo: [
          { required: true, message: '请选择箱子大小', trigger: 'blur' }
        ]
      },
      YesNo: [
        {
          id: 'Y',
          name: '是'
        },
        {
          id: 'N',
          name: '否'
        }
      ],
      isOpenHideOption: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      roleId: null,
      groupArr: []
    }
  },
  created() {
    // if (this.status) {
    //   this.detail.IsFree = 'N'
    //   this.detail.IsDepositTel = 'N'
    // } else {
    //   if (!this.detail.IsFree) this.detail.IsFree = 'N'
    // }
    this.roleId = this.$store.getters.roles.RoleId
    this.getDeviceGroup()
  },
  mounted() {
    this.$nextTick(() => {
      var this_ = this
      BaiduMap.init().then((BMap) => {
        const map = new BMap.Map('bmap', { enableMapClick: true })
        let marker = ''
        if (this_.detail.Address && this_.detail.Longitude !== 0 && this_.detail.Latitude !== 0) {
          map.centerAndZoom(new BMap.Point(this_.detail.Longitude, this_.detail.Latitude), 11)
          marker = new BMap.Marker(new BMap.Point(this_.detail.Longitude, this_.detail.Latitude))
        } else {
          map.centerAndZoom('北京', 11)
          marker = new BMap.Marker(new BMap.Point(116.403613, 39.91513))
        }
        var top_left_navigation = new BMap.NavigationControl() // 左上角，添加默认缩放平移控件
        map.addControl(top_left_navigation)
        map.addOverlay(marker)
        map.enableScrollWheelZoom(true)
        var geoc = new BMap.Geocoder()
        map.addEventListener('click', function(e) {
          map.clearOverlays()
          if (!this_.detail) {
            this_.detail = {}
          }
          geoc.getLocation(e.point, function(rs) {
            console.log(rs)
            var addComp = rs.addressComponents
            this_.detail.Longitude = e.point.lng
            this_.detail.Latitude = e.point.lat
            this_.detail.Address = addComp.city + addComp.district + addComp.street + addComp.streetNumber
            marker = new BMap.Marker(new BMap.Point(this_.detail.Longitude, this_.detail.Latitude))
            map.addOverlay(marker)
          })
        })
      })
      if (this.detail.AdvPic) {
        const { AdvPic } = this.detail
        this.$refs.upload.init({ fileExplainName: AdvPic, filePath: AdvPic, id: AdvPic }, 360, 200)
      } else {
        this.$refs.upload.init('', 360, 200)
      }
    })
  },
  methods: {
    uploadChange(e) {
      console.log(e)
      this.detail.AdvPic = e ? e.url : ''
    },
    // 分组接口
    updateGroup(item) {
      this.$prompt('请输入分组名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /./,
        inputErrorMessage: '请输入分组名称',
        inputPlaceholder: '请输入分组名称',
        inputValue: item ? item.GroupName : null
      }).then(({ value }) => {
        if (item) {
          modDeviceGroup({ GroupId: item.GroupId, GroupName: value, GroupDescription: item.GroupDescription }).then(res => {
            this.$message.success('修改成功')
            this.getDeviceGroup()
          })
        } else {
          addDeviceGroup({ GroupId: 0, GroupName: value }).then(res => {
            this.$message.success('添加成功')
            this.getDeviceGroup()
          })
        }
      })
    },
    // 获取分组信息
    getDeviceGroup() {
      qryDeviceGroup({ pageIndex: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        this.groupArr = res.LsList
      })
    },
    // 输入地址解析经纬度
    handleInputAddress() {
      if (this.detail.Address) {
        this.$nextTick(() => {
          BaiduMap.init().then(BMap => {
            const map = new BMap.Map('bmap', { enableMapClick: true })
            let marker = ''
            const top_left_navigation = new BMap.NavigationControl() // 左上角，添加默认缩放平移控件
            map.addControl(top_left_navigation)
            map.enableScrollWheelZoom(true)
            const geo = new BMap.Geocoder()
            geo.getPoint(this.detail.Address, (rs) => {
              if (rs) {
                map.centerAndZoom(rs, 16)
                map.addOverlay(new BMap.Marker(rs))
                this.detail.Longitude = rs.lng
                this.detail.Latitude = rs.lat
              }
            })
            map.addEventListener('click', (e) => {
              map.clearOverlays()
              geo.getLocation(e.point, (rs) => {
                console.log(rs)
                var addComp = rs.addressComponents
                this.detail.Longitude = e.point.lng
                this.detail.Latitude = e.point.lat
                this.detail.Address = addComp.city + addComp.district + addComp.street + addComp.streetNumber
                marker = new BMap.Marker(new BMap.Point(this.detail.Longitude, this.detail.Latitude))
                map.addOverlay(marker)
              })
            })
          })
        })
      }
    },
    // 提交
    submit(formName) {
      this.detail.Did = (this.detail.DId ? this.detail.DId : -1)
      this.detail.HideProportion = this.detail.IsOpenHide ? this.detail.HideProportion : 0
      var a = this.status
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!a) {
            this.$confirm('此修改操作将重置箱子列表，是否继续?如有不用的箱子请点击详情重新删除', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              txDevice(this.detail).then(request => {
                if (request) {
                  this.$message({
                    message: a ? '添加成功' : '修改成功',
                    type: 'success'
                  })
                  if (this.detail.DId) {
                    const boxInfo = new window.proto.SocketCmd.CmdHeader()
                    boxInfo.setCmdcode(0x0207)
                    boxInfo.setIdentity(this.$store.getters.roles.LogNo)
                    boxInfo.setOppositeid(this.detail.Identity)
                    boxInfo.setTimetoken(new window.Date().getTime())
                    this.cySocket.sendMsg(boxInfo.serializeBinary())
                  }
                  this.$emit('backList')
                }
              })
            }).catch(() => {})
            return
          }
          txDevice(this.detail).then(request => {
            if (request) {
              this.$message({
                message: a ? '添加成功' : '修改成功',
                type: 'success'
              })
              if (this.detail.DId) {
                const boxInfo = new window.proto.SocketCmd.CmdHeader()
                boxInfo.setCmdcode(0x0207)
                boxInfo.setIdentity(this.$store.getters.roles.LogNo)
                boxInfo.setOppositeid(this.detail.Identity)
                boxInfo.setTimetoken(new window.Date().getTime())
                this.cySocket.sendMsg(boxInfo.serializeBinary())
              }
              this.$emit('backList')
            }
          })
        }
      })
    },
    cancel() {
      this.$emit('backList1')
    }
  }
}
</script>
<style>
#bmap {
  width: 100%;
  height: 315px;
}
.el-form-item__label{
  float: left;
}
</style>
